<div class="card">
  <app-grid-server-side
    storageKey="outgoing-email-messages"
    pageTitle="Outgoing Email Messages"
    [colDefs]="$any(colDefs())"
    [rowData]="[]"
    [totalRows]="totalRows()"
    [maxBlocksInCache]="maxBlocksInCache"
    [excelStyles]="excelStyles"
    [defaultExcelExportParams]="excelExportParams"
    [gridOptions]="gridOptions"
    [suppressRowClickSelection]="true"
    [serverSideDatasource]="dataSource()"
    [paginationPageSize]="defaultPageSize"
    [cacheBlockSize]="cacheBlockSize"
    (gridReady)="onGridReady($event)"
    (select)="selectEmailRecord($event)"
    (search)="onSearch($event)"
  >
    <div class="grid-controls-end d-flex justify-content-end gap-12">
      @if (checkedEmailRecords.length) {
        <app-button
          *appHasRole="['Admin', 'Manager', 'Preparer']"
          title="Export selected messages"
          btnColor="white"
          iconClass="icon ic-download-20"
          (clickBtn)="exportSelectedEmailMessagesToXls()"
          [isDisabled]="!totalRows || modalOpened()"
        />
      } @else {
        <app-button
          *appHasRole="['Admin', 'Manager', 'Preparer']"
          title="Export"
          btnColor="white"
          iconClass="icon ic-download-20"
          [isDisabled]="!totalRows || modalOpened()"
          (clickBtn)="exportEmailMessagesList(false, ExportTypeEnum.EXCEL)"
        />
      }
    </div>
  </app-grid-server-side>
</div>

<app-email-details
  [isOuterLoading]="isDetailsLoading"
  [opened]="!!$selectedEmailRecord()"
  [emailRecord]="$selectedEmailRecord()"
  [currentEmailMessageIndex]="currentEmailRecordIndex"
  [totalRows]="totalRows()"
  [currentEmailMessageItemNumber]="currentEmailMessageItemNumber"
  (close)="onCloseDetails()"
  (getNextEmailMessage)="nextEmailMessage()"
  (getPreviousEmailMessage)="previousEmailMessage()"
  (refreshData)="reloadGrid()"
/>
